import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3 text-gray-800",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
  })
], -1)
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index,
        class: "flex items-center mt-2"
      }, [
        _hoisted_2,
        _createElementVNode("span", {
          class: "ml-2",
          title: item.tooltip
        }, _toDisplayString(item.text), 9, _hoisted_3)
      ]))
    }), 128))
  ]))
}